import React, { useState, useEffect } from "react";
import * as yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "../Config/axios";
import Swal from "sweetalert2";
import PopUp from "./PopUp";

const schema = yup.object().shape({
  first_name: yup.string().required("Нэр заавал бөглөнө үү"),
  last_name: yup.string().required("Овог заавал бөглөнө үү"),
  email: yup
    .string()
    .email("Имэйлийн формат таарахгүй байна")
    .required("Имэйл заавал бөглөнө үү"),
  number: yup.string().required("Утас заавал бөглөнө үү"),
  branch: yup.string().required("Салбар заавал бөглөнө үү"),
  // district: yup.string().required('Сум/дүүрэг заавал бөглөнө үү')
});

function CustomForm() {
  // const [city, setCity] = useState([]);
  // const [district, setDistrict] = useState([]);
  const [branch, setBranch] = useState([]);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    number: "",
    branch: "",
  });
  // function getSplitName(value, code) {
  //     let name = 'Байхгүй';
  //     if (value) {
  //         let splitName = value.split('--');
  //         if (splitName && code === 'name') {
  //             return splitName[1];
  //         }
  //         if (splitName && code === 'code') {
  //             return splitName[0];
  //         }
  //     }
  //     return name;
  // }

  useEffect(() => {
    axios
      .get("/order/branch")
      .then((res) => {
        setBranch(res.data.data);
      })
      .catch(() => {});
  }, []);

  const submit = (values, { setSubmitting, resetForm }) => {
    axios
      .post(
        "order/save",
        {
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          number: values.number,
          branch: values.branch,
        },
        {
          auth: {
            username: "test",
            password: "test@dm1n",
          },
        }
      )
      .then((res) => {
        let { code, message } = res.data;

        if (code === 200) {
          Swal.fire({
            title: "Амжилттай",
            icon: "success",
            text: "Танд 24 цагийн дотор хариу өгөх болно.",
            confirmButtonText: "Ok",
          }).then(() => {
            // Reset the form after successful submission
            resetForm();
          });
        } else {
          Swal.fire({
            title: message,
            icon: "error",
            confirmButtonText: "Болих",
          });
        }
      })
      .catch(() => {})
      .finally(() => {
        setSubmitting(false);
      });
  };

  // const handleChangeCity = async (event) =>{
  //     const target = event.target;
  //     setFormData({
  //         ...formData,
  //         city: target?.value
  //     });
  //     getDistrict(target?.value);
  // }
  const handleChangeBranch = async (event) => {
    const target = event.target;
    setFormData({
      ...formData,
      branch: target?.value,
    });
  };
  return (
    <div className={"form-background"}>
      <Formik
        initialValues={formData}
        validationSchema={schema}
        // onSubmit={(values, {setSubmitting}) => {
        //     setTimeout(() => {
        //         alert(JSON.stringify(values, null, 2));
        //         setSubmitting(false);
        //     }, 400);
        // }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          submit(values, { setSubmitting, resetForm });
        }}
      >
        {({ setFieldValue, isSubmitting }) => (
          <Form className={"form-content"}>
            <div className={"form-group"}>
              <label htmlFor="last_name">Овог *</label>
              <Field type="text" className={"form-control"} name="last_name" />
              <div className={"helper-text"}>
                <ErrorMessage
                  className={"form-text text-muted"}
                  name="last_name"
                />
              </div>
            </div>
            <div className={"form-group"}>
              <label htmlFor="first_name">Нэр *</label>
              <Field type="text" className={"form-control"} name="first_name" />
              <div className={"helper-text"}>
                <ErrorMessage name="first_name" />
              </div>
            </div>
            <div className={"form-group"}>
              <label htmlFor="email">И-мэйл хаяг *</label>
              <Field type="email" className={"form-control"} name="email" />
              <div className={"helper-text"}>
                <ErrorMessage name="email" />
              </div>
            </div>
            <div className={"form-group"}>
              <label htmlFor="number">Гар утас *</label>
              <Field type="phone" className={"form-control"} name="number" />
              <div className={"helper-text"}>
                <ErrorMessage name="number" />
              </div>
            </div>
            <div className={"form-group"}>
              <label htmlFor="city">Салбар *</label>
              <Field
                as="select"
                name="branch"
                placeholder="Салбар сонгох"
                className={"form-control"}
                value={formData.branch}
                onChange={(event) => {
                  handleChangeBranch(event);
                  setFieldValue("branch", event.target.value);
                }}
              >
                <option value="">Салбар сонгох</option>
                {branch &&
                  branch.map(function (item, index) {
                    return (
                      <option key={index} value={item.brch_code}>
                        {item.name}
                      </option>
                    );
                  })}
              </Field>
              <div className={"helper-text"}>
                <ErrorMessage name="branch" />
              </div>
            </div>
            {/*<div className={'form-group'}>*/}
            {/*    <label htmlFor="district">Сум/Дүүрэг *</label>*/}
            {/*    <Field*/}
            {/*        as="select" name="district"*/}
            {/*        placeholder='Хот/Аймаг сонгох'*/}
            {/*        className={'form-control'}*/}
            {/*        value={formData.district}*/}
            {/*        onChange={(event) => {setFormData({*/}
            {/*            ...formData,*/}
            {/*            district: event.target?.value*/}
            {/*        }); setFieldValue("district", event.target.value);}}*/}
            {/*    >*/}
            {/*        <option value=''>Сум/Дүүрэг сонгох</option>*/}
            {/*        {district &&*/}
            {/*            district.map(function (item, index) {*/}
            {/*                return (*/}
            {/*                    <option*/}
            {/*                        key={index}*/}
            {/*                        value={item.distcode + '--' + item.name}*/}
            {/*                    >*/}
            {/*                        {item.name}*/}
            {/*                    </option>*/}
            {/*                );*/}
            {/*            })}*/}
            {/*    </Field >*/}
            {/*    <div className={'helper-text'}><ErrorMessage name="district"/></div>*/}
            {/*</div>*/}
            <button
              type="submit"
              className={"btn btn-primary"}
              disabled={isSubmitting}
            >
              {isSubmitting && (
                <div
                  className="spinner-border"
                  style={{ height: "18px", width: "18px" }}
                  role="status"
                >
                  <span className="sr-only"></span>
                </div>
              )}{" "}
              Илгээх
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default CustomForm;
